import { ErrorComponent, ThemedLayoutV2 } from '@refinedev/mui';
import { NavigateToResource } from '@refinedev/react-router';
import { Route, Routes } from 'react-router';
import { Header } from '../../components/header/index.tsx';
import * as Author from './author/index.ts';
import * as Document from './document/index.ts';
import * as Pickup from './pickup/index.ts';
import * as Sector from './sector/index.ts';
import * as Series from './series/index.ts';
import * as Timeline from './timeline/index.ts';
import * as Topic from './topic/index.ts';

export default () => (
  <ThemedLayoutV2 Header={Header}>
    <Routes>
      <Route index element={<NavigateToResource resource="contents/documents" />} />
      <Route path="/documents">
        <Route index element={<Document.DocumentList />} />
        <Route path="create" element={<Document.DocumentForm action="create" />} />
        <Route path="edit/:id" element={<Document.DocumentForm action="edit" />} />
        <Route path="show/:id" element={<Document.DocumentShow />} />
      </Route>
      <Route path="/pickup">
        <Route index element={<Pickup.TopPickupForm />} />
      </Route>
      <Route path="/sectors">
        <Route index element={<Sector.SectorList />} />
        <Route path="create" element={<Sector.SectorForm action="create" />} />
        <Route path="edit/:id" element={<Sector.SectorForm action="edit" />} />
      </Route>
      <Route path="/topics">
        <Route index element={<Topic.TopicList />} />
        <Route path="create" element={<Topic.TopicForm action="create" />} />
        <Route path="edit/:id" element={<Topic.TopicForm action="edit" />} />
      </Route>
      <Route path="/series">
        <Route index element={<Series.SeriesList />} />
        <Route path="create" element={<Series.SeriesForm action="create" />} />
        <Route path="edit/:id" element={<Series.SeriesForm action="edit" />} />
      </Route>
      <Route path="/timelines">
        <Route index element={<Timeline.TimelineList />} />
        <Route path="create" element={<Timeline.TimelineForm action="create" />} />
        <Route path="edit/:id" element={<Timeline.TimelineForm action="edit" />} />
        <Route path="show/:id" element={<Timeline.TimelineShow />} />
      </Route>
      <Route path="/authors">
        <Route index element={<Author.AuthorList />} />
        <Route path="create" element={<Author.AuthorForm action="create" />} />
        <Route path="edit/:id" element={<Author.AuthorForm action="edit" />} />
        <Route path="show/:id" element={<Author.AuthorShow />} />
      </Route>
      <Route path="*" element={<ErrorComponent />} />
    </Routes>
  </ThemedLayoutV2>
);
